import { BaseBetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2Pick } from '../../../../../core/picks/betslip-v2-pick';
import { CutOffDateReached } from '../../../errors/result/cut-off-date-reached';
import { PickUpdaterBase } from './pick-updater';

export default class BetslipErrorCutoffDateReachedUpdater extends PickUpdaterBase<CutOffDateReached> {
    protected updateV1Pick(pick: BetslipV1Pick, error: CutOffDateReached): void {
        if (error.cutOffDate) {
            pick.event.cutOffDate = error.cutOffDate;
        }
    }

    protected updateV2Pick(pick: BetslipV2Pick, error: CutOffDateReached): void {
        pick.setMarketInvisible();
    }

    protected updateGroupPick(pick: BaseBetslipGroupPick, error: CutOffDateReached): void {
        pick.isSuspended = true;
    }
}
